import constants from "./constants";
import UIUtils from "./util/UIUtils";

export default {
  relayers: {
    basic: UIUtils.getTip("Basic details of the relayer."),
    addresses: UIUtils.getTip("All relayer chains and address balance per relayer (where address is shared by relayers)."),
  }
};
